import { BACKEND_URL } from "../views/common/utils/constants";
import { IAPIResponse, INameValuePair } from "../views/common/utils/interfaces";
import { errorToastify } from "../views/common/utils/Toasty";
import { CustomAxios } from "./customAxios";

export const getPurchaseOwners = async () => {
  try {
    const { data: result }: IAPIResponse = await CustomAxios().get(
      `${BACKEND_URL}/options/purchase-request-owners`
    );

    if (!result?.status) {
      throw new Error(result?.message);
    }

    return result?.data as INameValuePair[];
  } catch (error) {
    if (typeof error === "string") {
      errorToastify(error);
    }
  }
};

export const getBuyerTypes = async () => {
  try {
    const { data: result }: IAPIResponse = await CustomAxios().get(
      `${BACKEND_URL}/options/buyer-types`
    );

    if (!result?.status) {
      throw new Error(result?.message);
    }

    return result?.data as INameValuePair[];
  } catch (error) {
    if (typeof error === "string") {
      errorToastify(error);
    }
  }
};

export const getMeansOfIdentification = async () => {
  try {
    const { data: result }: IAPIResponse = await CustomAxios().get(
      `${BACKEND_URL}/options/means-of-identification`
    );

    if (!result?.status) {
      throw new Error(result?.message);
    }

    return result?.data as INameValuePair[];
  } catch (error) {
    if (typeof error === "string") {
      errorToastify(error);
    }
  }
};

export const getPaymentTypes = async () => {
  try {
    const { data: result }: IAPIResponse = await CustomAxios().get(
      `${BACKEND_URL}/options/payment-types`
    );

    if (!result?.status) {
      throw new Error(result?.message);
    }

    return result?.data as INameValuePair[];
  } catch (error) {
    if (typeof error === "string") {
      errorToastify(error);
    }
  }
};

export const getGendersList = async () => {
  try {
    const { data: result }: IAPIResponse = await CustomAxios().get(
      `${BACKEND_URL}/options/genders`
    );

    if (!result?.status) {
      throw new Error(result?.message);
    }

    return result?.data as INameValuePair[];
  } catch (error) {
    if (typeof error === "string") {
      errorToastify(error);
    }
  }
};

export const getSayYesNo = async () => {
  try {
    const { data: result }: IAPIResponse = await CustomAxios().get(
      `${BACKEND_URL}/options/yes-no`
    );

    if (!result?.status) {
      throw new Error(result?.message);
    }

    return result?.data as INameValuePair[];
  } catch (error) {
    if (typeof error === "string") {
      errorToastify(error);
    }
  }
};

export const getEmploymentStatuses = async () => {
  try {
    const { data: result }: IAPIResponse = await CustomAxios().get(
      `${BACKEND_URL}/options/employment-statuses`
    );

    if (!result?.status) {
      throw new Error(result?.message);
    }

    return result?.data as INameValuePair[];
  } catch (error) {
    if (typeof error === "string") {
      errorToastify(error);
    }
  }
};

export const getNextOfKinRelationships = async () => {
  try {
    const { data: result }: IAPIResponse = await CustomAxios().get(
      `${BACKEND_URL}/options/next-of-kin-relationships`
    );

    if (!result?.status) {
      throw new Error(result?.message);
    }

    return result?.data as INameValuePair[];
  } catch (error) {
    if (typeof error === "string") {
      errorToastify(error);
    }
  }
};

export const getDownloadFile = async (downloadUrl: string) => {
  try {
    const { data: result }: IAPIResponse = await CustomAxios().get(
      downloadUrl,
      {
        responseType: "blob",
      }
    );

    return result as any;
  } catch (error) {
    if (typeof error === "string") {
      errorToastify(error);
    }
  }
};
